module.exports = __webpack_public_path__ + "img/branton-contact.3225e658.jpg";